/**
 * Регистрирует паттерн диагональной клетки (crosshatch 45°) в Mapbox.
 * Используется для invisible-зон V2.
 *
 * @param {mapboxgl.Map} map
 * @param {string} patternId — уникальный id image в Mapbox
 * @param {string} color — цвет линий штриховки
 */
export const registerCrossHatchPattern = (map, patternId, color) => {
    const size = 8;
    const canvas = document.createElement('canvas');
    canvas.width = size;
    canvas.height = size;
    const ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, size, size);
    ctx.globalAlpha = 0.7;
    ctx.strokeStyle = color;
    ctx.lineWidth = 1;
    ctx.lineCap = 'square';
    // Диагональ ↘ (////)
    ctx.beginPath();
    ctx.moveTo(0, 0);
    ctx.lineTo(size, size);
    ctx.moveTo(-size / 2, size / 2);
    ctx.lineTo(size / 2, -size / 2);
    ctx.moveTo(size / 2, size + size / 2);
    ctx.lineTo(size + size / 2, size / 2);
    ctx.stroke();
    // Диагональ ↙ (\\\\)
    ctx.beginPath();
    ctx.moveTo(size, 0);
    ctx.lineTo(0, size);
    ctx.moveTo(size / 2, -size / 2);
    ctx.lineTo(size + size / 2, size / 2);
    ctx.moveTo(-size / 2, size / 2);
    ctx.lineTo(size / 2, size + size / 2);
    ctx.stroke();
    const url = canvas.toDataURL('image/png');
    map.loadImage(url, (error, image) => {
        if (error) {
            console.error('[CrossHatchPattern] Failed to load:', error);
            return;
        }
        if (map.hasImage(patternId)) {
            map.removeImage(patternId);
        }
        map.addImage(patternId, image, { sdf: false, pixelRatio: 2 });
    });
};
